import styled from "styled-components";

const Main = styled.main`
  height: 100vh;
  font-family: "Cinzel", serif;

  a[target] {
    text-decoration: none;
    text-align: center;
    display: block;
    width: 100%;
    padding: 20px 40px;
    margin-top: 50px;
    border: none;
    outline: none;
    background-color: ${({ theme }) => theme.color.azure};
    color: #fff;
    font-size: 1.3rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-top: 10px;
    }
  }
  section {
    display: flex;
    justify-content: space-between;
    height: 350px;
    margin-top: 20px;
    gap: 70px;
    padding: 0 50px;
    overflow: hidden;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      height: 1100px;
      padding: 10px 20px;
      gap: 0;
      justify-content: center;
    }
  }
`;

export default Main;
